import styled from "styled-components/macro"

export const TypographyAnimationContainerElement = styled.div`
  width: 100%;
`
